import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { KeycloakAngularModule } from 'keycloak-angular';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UseHttpImageSourcePipeModule } from '@this-dot/ng-utils';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
registerLocaleData(localeDe);

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy',
};

export function playerFactory() {
    return player;
}

@NgModule({
    declarations: [AppComponent],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'de-DE',
        },
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        // Core module of your application
        CoreModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        UseHttpImageSourcePipeModule.forRoot({
            loadingImagePath: '/assets/images/logo/box.gif',
            errorImagePath: '/assets/images/your-custom-error-image.png',
        }),

        // Layout module of your application
        LayoutModule,

        KeycloakAngularModule,
        MatDatepickerModule,
        MatNativeDateModule,

        LottieModule.forRoot({ player: playerFactory }),

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
